/* nt-fx-avaliacoes.js: leitor da avaliacao inteira, ampliar, abas e fileira das avaliacoes.
   copia do bloco javascript do sections/nt-reviews.liquid. a shopify so roda o javascript
   de uma secao quando aquela secao esta na pagina (__sections__ do compiled_assets/scripts.js), e a
   home nova usa a nt-fx-avaliacoes no lugar da nt-reviews: sem esta copia o leitor e as abas nao ligam.
   mudou o leitor la, mude aqui tambem. as guardas (data-ligado, data-nt-fileira, data-nt-aquece)
   deixam a copia segura mesmo se as duas secoes estiverem na mesma pagina. unica diferenca: o aviso
   do vex no leitor (data-nt-anterior), que so a nt-fx-avaliacoes tem. */
/* capa do youtube no cartão: a grande falta em parte dos vídeos, e no lugar dela vem um cinza de 120px.
   a média tem faixas pretas em cima e embaixo; a classe avisa o css para cortá-las */
(function () {
  function capa(img) {
    var media = img.getAttribute('data-nt-yt-capa');
    if (!media || (img.complete && img.naturalWidth > 120)) return;
    if (!img.complete) return;
    img.removeAttribute('data-nt-yt-capa');
    img.classList.add('nt-rev__yt-media');
    img.src = media;
  }
  function conferir(evento) {
    var img = evento.target;
    if (img && img.matches && img.matches('img[data-nt-yt-capa]')) capa(img);
  }
  document.addEventListener('load', conferir, true);
  document.addEventListener('error', conferir, true);
  document.querySelectorAll('img[data-nt-yt-capa]').forEach(capa);
})();

/* leitor da avaliação inteira. o cartão inteiro abre o diálogo, que copia os dados do cartão */
(function () {
  var contador = 0;

  /* a foto inteira no leitor vem no tamanho da caixa: uns 445px no desktop, a largura da tela menos a margem
     no celular. em densidade 3 ela é pedida como em densidade 2, como a do cartão. a de 1800px fica para o ampliar */
  var TELA = '(min-width: 1024px) 445px, (min-resolution: 2.5dppx) and (min-width: 584px) 373px, ' +
             '(min-resolution: 2.5dppx) calc(66.7vw - 16px), (min-width: 584px) 560px, calc(100vw - 24px)';

  /* no celular a foto preenche a caixa, como na referência, com o mesmo corte 4:5 do cartão: o arquivo
     cortado tem a nitidez certa para a caixa, e a foto inteira continua no ampliar. vídeo fica inteiro.
     com o celular deitado a caixa vai para o lado do texto e ocupa uns 45% da tela */
  var CORTE = '(orientation: landscape) and (max-height: 600px) 45vw, ' +
              '(min-resolution: 2.5dppx) and (min-width: 584px) 373px, ' +
              '(min-resolution: 2.5dppx) calc(66.7vw - 16px), (min-width: 584px) 560px, calc(100vw - 24px)';
  /* a barra de controles do vídeo no chrome e no firefox deixa um vão no meio, acima da linha do vídeo, onde as
     miniaturas cabem. a do safari, e a de todo navegador do iphone e do ipad, põe a linha do vídeo no meio da
     barra: lá elas ficam acima dos botões */
  var barraComVao = (function () {
    var ua = navigator.userAgent;
    var ios = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    var safari = /Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/.test(ua);
    return !ios && !safari;
  })();
  var celular = window.matchMedia('(max-width: 1023.98px)');
  var deitado = window.matchMedia('(orientation: landscape) and (max-height: 600px)');
  /* a caixa do celular é 4:5 até a altura de 55% da tela. em tablet deitado ou janela baixa ela fica mais larga
     que alta, e o corte 4:5 seria cortado de novo (cabeças de fora): aí a foto fica inteira, como no desktop.
     com o celular deitado a caixa ao lado do texto é quase quadrada e o corte cabe */
  function caixaAlta() {
    if (deitado.matches) return true;
    var largura = Math.min(window.innerWidth - 24, 560);
    var altura = Math.min(largura * 1.25, window.innerHeight * 0.55);
    return altura >= largura * 0.95;
  }
  function preenche(item) {
    return !!(item && item.kind === 'image' && item.corte && celular.matches && caixaAlta());
  }

  var catalogos = new WeakMap();
  function lerCatalogo(card) {
    if (catalogos.has(card)) return catalogos.get(card);
    var tag = card.querySelector('script[data-nt-media]');
    var lista = [];
    if (tag) {
      try { lista = JSON.parse(tag.textContent) || []; } catch (erro) { lista = []; }
    }
    catalogos.set(card, lista);
    return lista;
  }

  function capaDe(item) {
    if (item.kind === 'image') return item.src;
    if (item.kind === 'youtube') return 'https://i.ytimg.com/vi/' + item.id + '/hqdefault.jpg';
    return item.poster || '';
  }

  /* o mesmo srcset e o mesmo sizes em todo lugar que pede a foto do leitor: assim o navegador escolhe o
     mesmo arquivo, e o que foi pedido antes já está no cache quando o leitor abre */
  function porNaTela(el, item) {
    if (preenche(item)) {
      el.sizes = CORTE;
      el.srcset = item.corte;
      el.setAttribute('data-nt-corte', '');
      return;
    }
    if (!item.tela) return;
    el.sizes = TELA;
    el.srcset = item.tela;
  }

  /* pede antes a foto que o leitor vai mostrar. a capa do youtube no leitor é a mesma do cartão */
  var aquecidas = {};
  function aquecerFoto(item) {
    if (!item || item.kind === 'youtube') return;
    var chave = (preenche(item) ? item.corte : item.tela) || capaDe(item);
    if (!chave || aquecidas[chave]) return;
    var img = new Image();
    img.decoding = 'async';
    porNaTela(img, item);
    img.src = capaDe(item);
    aquecidas[chave] = img;
  }
  function aquecerLeitor(card, todas) {
    if (!card) return;
    var lista = lerCatalogo(card);
    (todas ? lista : lista.slice(0, 1)).forEach(aquecerFoto);
  }

  /* a foto de 1800px só é pedida quando a pessoa mostra que vai ampliar, para não baixar à toa */
  var grandes = {};
  function pedirGrande(item) {
    if (!item || item.kind !== 'image' || !item.src) return null;
    if (!grandes[item.src]) {
      var img = new Image();
      img.decoding = 'async';
      img.src = item.src;
      grandes[item.src] = img;
    }
    return grandes[item.src];
  }

  /* no celular a foto do leitor é o corte 4:5 e não serve de provisória para o ampliar, que mostra a foto
     inteira: a provisória é a menor foto inteira da lista da tela, pedida já no toque */
  var inteiras = {};
  function pedirInteira(item, devagar) {
    var primeira = ((item && item.tela) || '').split(',')[0].trim().split(/\s+/);
    var largura = parseInt(primeira[1], 10);
    if (!primeira[0] || !largura) return null;
    if (!inteiras[primeira[0]]) {
      var img = new Image();
      img.decoding = 'async';
      if (devagar) img.fetchPriority = 'low';
      img.src = primeira[0];
      inteiras[primeira[0]] = img;
    }
    return { url: primeira[0], w: largura };
  }

  /* enquanto a de 1800px chega, o ampliar mostra uma foto menor no tamanho que a grande vai ocupar (o srcset
     declara a largura da grande), e troca por ela sem mudar o tamanho. no desktop é a foto do leitor, que já
     está no cache; a largura do arquivo sai do width= da url, porque com srcset o naturalWidth já vem dividido
     pela densidade */
  function mostrarProvisoria(peca, origem, item) {
    if (!item || !item.w || !origem || origem.tagName !== 'IMG') return;
    var grande = pedirGrande(item);
    if (!grande || (grande.complete && grande.naturalWidth)) return;
    var url = '';
    var largura = 0;
    if (origem.hasAttribute('data-nt-corte')) {
      var menor = pedirInteira(item);
      if (menor) { url = menor.url; largura = menor.w; }
    } else if (origem.complete && origem.naturalWidth) {
      var achou = /[?&]width=(\d+)/.exec(origem.currentSrc || '');
      if (achou) { url = origem.currentSrc; largura = Number(achou[1]); }
    }
    if (!url || !largura) return;
    peca.sizes = item.w + 'px';
    peca.srcset = url + ' ' + largura + 'w';
    /* a grande entra declarada com a própria largura (densidade 1): só tirar o srcset deixava o chrome com a
       densidade da provisória, e a foto pequena crescia na troca */
    grande.addEventListener('load', function () {
      peca.srcset = item.src + ' ' + item.w + 'w';
    }, { once: true });
  }

  function quieto() {
    return window.matchMedia &&
           window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* a foto que sai do leitor para o lightbox cresce do lugar onde estava, e volta encolhendo */
  function crescerDe(peca, de) {
    if (!peca || !de || !de.width || quieto() || !peca.animate) return;
    var para = peca.getBoundingClientRect();
    if (!para.width || !para.height) return;
    peca.animate(
      [
        {
          transformOrigin: 'top left',
          transform: 'translate(' + (de.left - para.left) + 'px, ' +
                     (de.top - para.top) + 'px) scale(' +
                     (de.width / para.width) + ', ' +
                     (de.height / para.height) + ')',
          opacity: 0.55
        },
        { transformOrigin: 'top left', transform: 'none', opacity: 1 }
      ],
      { duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
    );
  }

  function ligar(raiz) {
    var folha = raiz.querySelector('[data-nt-leitor]');
    if (!folha || folha.dataset.ligado) return;
    folha.dataset.ligado = '1';
    var gradId = 'nt-star-leitor-' + (++contador);

    function q(sel) { return folha.querySelector(sel); }
    var nome = q('[data-nt-leitor-nome]');
    var ok = q('[data-nt-leitor-ok]');
    var data = q('[data-nt-leitor-data]');
    var estrelas = q('[data-nt-leitor-estrelas]');
    var titulo = q('[data-nt-leitor-titulo]');
    var texto = q('[data-nt-leitor-texto]');
    var corpo = q('[data-nt-leitor-corpo]');
    var prod = q('[data-nt-leitor-prod]');
    var prodImg = q('[data-nt-leitor-prod-img]');
    var prodNome = q('[data-nt-leitor-prod-nome]');
    var prodLink = q('[data-nt-leitor-prod-link]');
    var aviso = q('[data-nt-leitor-anterior]');
    var painel = q('[data-nt-leitor-midia]');
    var quadro = q('[data-nt-leitor-quadro]');
    var btExpandir = q('[data-nt-leitor-expandir]');
    var minis = q('[data-nt-leitor-minis]');
    var btPrev = q('[data-nt-leitor-prev]');
    var btNext = q('[data-nt-leitor-next]');
    var contaRev = q('[data-nt-leitor-conta]');
    var grade = raiz.querySelector('nt-reviews');

    var atual = null;
    var midias = [];
    var iMidia = 0;
    /* aberto pelo "ampliar": ao fechar a foto, o leitor volta na mesma avaliação e na mesma mídia */
    var voltarPara = null;

    /* anda por todas as avaliações da aba aberta, e não só pelas da página */
    function todosCartoes() {
      if (grade && grade.cards) return grade.cards;
      return Array.prototype.filter.call(
        raiz.querySelectorAll('[data-nt-review]'),
        function (c) { return !c.dataset.ntFora; }
      );
    }

    /* a fileira acompanha o leitor: fechar cai na página da avaliação que estava aberta */
    function sincronizarPagina(card) {
      if (!grade || !grade.cards || !grade.size || !grade.to) return;
      var i = grade.cards.indexOf(card);
      if (i < 0) return;
      var pagina = Math.floor(i / grade.size);
      if (pagina !== grade.page) grade.to(pagina);
      mostrarNaFileira(card);
    }

    /* no celular a fileira rola de lado: a avaliação aberta que não está inteira à vista vai para o começo dela */
    function mostrarNaFileira(card) {
      if (grade.scrollWidth <= grade.clientWidth + 1) return;
      var borda = parseFloat(getComputedStyle(grade).scrollPaddingLeft) || 0;
      var r = card.getBoundingClientRect();
      var g = grade.getBoundingClientRect();
      if (r.left >= g.left - 1 && r.right <= g.right + 1) return;
      grade.scrollLeft += r.left - g.left - borda;
    }

    /* as estrelas do cartão, com o degradê renomeado: o id repetido apontaria para o do cartão,
       que some quando a página da fileira muda */
    function copiarEstrelas(card) {
      estrelas.textContent = '';
      var fonte = card.querySelector('.nt-stars');
      if (!fonte) return;
      var copia = fonte.cloneNode(true);
      var grad = copia.querySelector('linearGradient');
      if (grad) {
        var antigo = 'url(#' + grad.id + ')';
        grad.id = gradId;
        copia.querySelectorAll('svg[fill]').forEach(function (s) {
          if (s.getAttribute('fill') === antigo) s.setAttribute('fill', 'url(#' + gradId + ')');
        });
      }
      estrelas.appendChild(copia);
    }

    function miniDe(item) {
      if (item.mini) return item.mini;
      if (item.kind === 'youtube') return 'https://i.ytimg.com/vi/' + item.id + '/mqdefault.jpg';
      return capaDe(item);
    }
    /* a capa do youtube e a média (a grande falta em parte dos vídeos e dava 404 no console). ela tem faixas
       pretas em cima e embaixo: a classe avisa o css para cortá-las no fundo desfocado */
    function reserva(el, item) {
      if (item.kind === 'youtube') el.classList.add('nt-rev__yt-media');
    }

    function pintarMidia() {
      quadro.textContent = '';
      painel.classList.remove('nt-rev__leitor-midia--tocando', 'nt-rev__leitor-midia--tocando-yt', 'nt-rev__leitor-midia--tocando-vao');
      var tem = midias.length > 0;
      folha.classList.toggle('nt-rev__leitor--sem-midia', !tem);
      painel.hidden = !tem;
      if (!tem) return;

      var item = midias[iMidia];
      var capa = capaDe(item);
      preenchia = preenche(item);

      /* o fundo é a própria foto, desfocada e escurecida, atrás da foto inteira. a foto que preenche a
         caixa no celular não deixa fundo à mostra */
      if (capa && !preenche(item)) {
        var fundo = document.createElement('img');
        fundo.className = 'nt-rev__quadro-fundo';
        reserva(fundo, item);
        porNaTela(fundo, item);
        fundo.src = capa;
        fundo.alt = '';
        fundo.setAttribute('aria-hidden', 'true');
        quadro.appendChild(fundo);
      }

      var img = document.createElement('img');
      img.className = 'nt-rev__quadro-media';
      reserva(img, item);
      porNaTela(img, item);
      img.src = capa;
      img.alt = '';
      quadro.appendChild(img);
      /* no celular, com o corte já na tela, a menor foto inteira vem em segundo plano: é a provisória do
         ampliar, que senão ficaria vazio até a grande chegar */
      if (preenchia) {
        img.addEventListener('load', function () { pedirInteira(item, true); }, { once: true });
      }

      if (item.kind !== 'image') {
        /* vídeo e youtube só carregam no clique */
        var play = document.createElement('button');
        play.type = 'button';
        play.className = 'nt-rev__quadro-play';
        play.setAttribute('aria-label', folha.dataset.ntPlayLabel || 'Ver vídeo');
        play.addEventListener('click', function () {
          /* o pôster do vídeo é a capa que já está na tela */
          var vista = img.currentSrc || item.poster;
          img.remove();
          play.remove();
          var tocador;
          if (item.kind === 'youtube') {
            tocador = document.createElement('iframe');
            tocador.src = 'https://www.youtube.com/embed/' + encodeURIComponent(item.id) +
                          '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
            tocador.title = 'YouTube';
            tocador.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            tocador.allowFullscreen = true;
            tocador.setAttribute('frameborder', '0');
          } else {
            tocador = document.createElement('video');
            tocador.src = item.src;
            if (vista) tocador.poster = vista;
            tocador.controls = true;
            tocador.autoplay = true;
            tocador.playsInline = true;
          }
          tocador.className = 'nt-rev__quadro-media nt-rev__quadro-media--tocando';
          /* os controles do tocador ficam embaixo: as miniaturas sobem enquanto ele está na tela */
          painel.classList.add(item.kind === 'youtube' ? 'nt-rev__leitor-midia--tocando-yt' : 'nt-rev__leitor-midia--tocando');
          if (item.kind !== 'youtube' && barraComVao) painel.classList.add('nt-rev__leitor-midia--tocando-vao');
          quadro.appendChild(tocador);
          /* o play que tinha o foco saiu da página: o foco passa para o tocador, dentro do leitor */
          tocador.focus({ preventScroll: true });
        });
        quadro.appendChild(play);
      }

      Array.prototype.forEach.call(minis.children, function (mini, i) {
        var on = i === iMidia;
        mini.classList.toggle('is-atual', on);
        mini.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* com o leitor aberto, se a tela muda (cruzar 1024px, girar o tablet, encolher a janela) a foto troca
       entre inteira e preenchendo a caixa */
    var preenchia = null;
    var revisando = 0;
    function revisar() {
      revisando = 0;
      var item = midias[iMidia];
      if (folha.open && item && item.kind === 'image' && preenche(item) !== preenchia) pintarMidia();
    }
    window.addEventListener('resize', function () {
      if (!revisando) revisando = requestAnimationFrame(revisar);
    });

    /* uma miniatura por foto ou vídeo, no lugar de setas e contador; tocar troca a mídia */
    function montarMinis() {
      minis.textContent = '';
      minis.hidden = midias.length < 2;
      if (midias.length < 2) return;
      midias.forEach(function (item, i) {
        var bt = document.createElement('button');
        bt.type = 'button';
        bt.className = 'nt-rev__mini' + (item.kind === 'image' ? '' : ' nt-rev__mini--video');
        bt.setAttribute('aria-label', (item.kind === 'image' ? 'Foto ' : 'Vídeo ') + (i + 1) + ' de ' + midias.length);
        var img = document.createElement('img');
        img.src = miniDe(item);
        img.alt = '';
        img.width = 46;
        img.height = 46;
        bt.appendChild(img);
        bt.addEventListener('click', function () {
          if (i === iMidia) return;
          iMidia = i;
          pintarMidia();
        });
        minis.appendChild(bt);
      });
    }

    function abrir(card) {
      atual = card;
      var d = card.dataset;

      nome.textContent = d.ntNome || '';
      ok.hidden = !('ntVerificado' in d);
      data.textContent = d.ntData || '';
      data.hidden = !d.ntData;
      if (d.ntQuando) data.setAttribute('datetime', d.ntQuando);
      else data.removeAttribute('datetime');
      copiarEstrelas(card);

      var t = card.querySelector('.nt-rev__cardtitle');
      titulo.textContent = t ? t.textContent : '';
      titulo.hidden = !t;
      var c = card.querySelector('.nt-rev__body');
      texto.textContent = c ? c.textContent : '';
      corpo.scrollTop = 0;

      /* avaliação da loja, ou sem produto achado, fica sem a linha do produto */
      if (d.ntProdutoUrl) {
        prod.hidden = false;
        prodNome.textContent = d.ntProduto || '';
        prodLink.href = d.ntProdutoUrl;
        prodImg.hidden = !d.ntProdutoImg;
        if (d.ntProdutoImg) prodImg.src = d.ntProdutoImg;
      } else {
        prod.hidden = true;
      }
      /* avaliação do vex, o modelo anterior: o aviso de que o novalite veio depois aparece só aqui no
         leitor, e o link dele toma o lugar do "ver produto", que levaria a outro produto */
      var anterior = 'ntAnterior' in d;
      folha.toggleAttribute('data-nt-anterior', anterior);
      if (aviso) aviso.hidden = !anterior;
      prodLink.hidden = anterior && !!(aviso && aviso.querySelector('a'));

      midias = lerCatalogo(card);
      iMidia = 0;
      montarMinis();
      pintarMidia();

      sincronizarPagina(card);

      var lista = todosCartoes();
      var pos = Array.prototype.indexOf.call(lista, card);
      contaRev.textContent = '';
      var focado = document.activeElement;
      btPrev.disabled = pos <= 0;
      btNext.disabled = pos < 0 || pos >= lista.length - 1;
      /* as outras fotos desta avaliação, para a miniatura trocar na hora, e a primeira da anterior e da próxima.
         só depois da foto que está na tela: na rede lenta elas dividiriam a banda com ela */
      var vizinhas = function () {
        if (atual !== card) return;
        aquecerLeitor(card, true);
        if (pos >= 0) {
          aquecerLeitor(lista[pos - 1]);
          aquecerLeitor(lista[pos + 1]);
        }
      };
      var naTela = quadro.querySelector('img.nt-rev__quadro-media');
      if (naTela && !naTela.complete) {
        naTela.addEventListener('load', vizinhas, { once: true });
        naTela.addEventListener('error', vizinhas, { once: true });
      } else {
        vizinhas();
      }
      /* chegou na primeira ou na última com o foco na seta que acabou de desligar: o foco iria para fora
         do leitor, e as setas do teclado parariam. ele passa para a outra seta, ou para o próprio leitor */
      if ((focado === btPrev || focado === btNext) && focado.disabled) {
        var outra = focado === btPrev ? btNext : btPrev;
        (outra.disabled ? folha : outra).focus({ preventScroll: true });
      }
      return pos >= 0 ? (d.ntNome || '') + ', avaliação ' + (pos + 1) + ' de ' + lista.length : '';
    }

    function mostrar() {
      if (!folha.open) folha.showModal();
      folha.focus({ preventScroll: true });
    }

    /* a intenção de abrir pede a foto do leitor antes do clique: o mouse em cima do cartão, o foco nele,
       o dedo encostando */
    function intencao(e) {
      var card = e.target.closest && e.target.closest('[data-nt-review]');
      if (card && grade && grade.contains(card)) aquecerLeitor(card);
    }
    /* o mouse que só cruza o cartão a caminho de outro lugar não conta: ele tem de parar um instante */
    var pairando = null;
    var pausa = 0;
    raiz.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var card = e.target.closest && e.target.closest('[data-nt-review]');
      if (card === pairando) return;
      pairando = card;
      window.clearTimeout(pausa);
      if (card) pausa = window.setTimeout(function () { if (pairando === card) intencao(e); }, 80);
    }, { passive: true });
    raiz.addEventListener('pointerdown', intencao, { passive: true });
    raiz.addEventListener('touchstart', intencao, { passive: true });
    raiz.addEventListener('focusin', intencao);

    raiz.addEventListener('click', function (e) {
      var botao = e.target.closest('[data-nt-ler]');
      if (!botao) return;
      var card = botao.closest('[data-nt-review]');
      if (!card) return;
      voltarPara = null;
      abrir(card);
      mostrar();
    });

    /* ampliar entrega o catálogo ao lightbox da página. o leitor fecha para dar lugar a ele, porque
       um elemento fixo não pinta acima de um diálogo em camada superior, e reabre quando a foto fecha */
    function expandir() {
      if (!midias.length || !atual) return;
      var lb = document.querySelector('nt-lightbox');
      if (!lb || typeof lb.open !== 'function') return;

      var origem = quadro.querySelector('.nt-rev__quadro-media');
      var de = null;
      if (origem) {
        var r = origem.getBoundingClientRect();
        de = { left: r.left, top: r.top, width: r.width, height: r.height };
      }

      voltarPara = { card: atual, midia: iMidia };
      folha.close();
      lb.open(midias, iMidia);

      var peca = lb.querySelector('.nt-lb__media');
      if (peca && peca.tagName === 'IMG' && !peca.complete) {
        mostrarProvisoria(peca, origem, midias[iMidia]);
        peca.addEventListener('load', function () { crescerDe(peca, de); }, { once: true });
      } else {
        crescerDe(peca, de);
      }
    }
    btExpandir.addEventListener('click', expandir);

    /* mouse no botão de ampliar, foco nele ou dedo encostando já pedem a foto grande */
    function vaiAmpliar() {
      if (!midias.length || !atual) return;
      pedirGrande(midias[iMidia]);
      if (preenche(midias[iMidia])) pedirInteira(midias[iMidia]);
    }
    ['pointerenter', 'focus', 'pointerdown'].forEach(function (tipo) {
      btExpandir.addEventListener(tipo, vaiAmpliar);
    });
    quadro.addEventListener('pointerdown', function (e) {
      if (e.target.classList.contains('nt-rev__quadro-media')) vaiAmpliar();
    });

    /* clicar na foto amplia, como o botão; em vídeo o clique é do play */
    quadro.addEventListener('click', function (e) {
      if (!e.target.classList.contains('nt-rev__quadro-media') || e.target.tagName !== 'IMG') return;
      if (quadro.querySelector('.nt-rev__quadro-play')) return;
      expandir();
    });

    /* reabre na volta seguinte do navegador: fechada pelo esc, a foto ainda está no meio do mesmo
       evento de tecla, e um diálogo aberto ali receberia o mesmo esc e fecharia junto */
    document.addEventListener('nt-lb-fechou', function (e) {
      if (!voltarPara) return;
      var volta = voltarPara;
      voltarPara = null;
      var de = e.detail && e.detail.de;
      window.setTimeout(function () {
        abrir(volta.card);
        if (volta.midia < midias.length) {
          iMidia = volta.midia;
          pintarMidia();
        }
        mostrar();
        crescerDe(quadro.querySelector('.nt-rev__quadro-media'), de);
      }, 0);
    });

    function andar(passo) {
      var lista = todosCartoes();
      var pos = Array.prototype.indexOf.call(lista, atual);
      var destino = lista[pos + passo];
      if (!destino) return;
      var anuncio = abrir(destino);
      /* o nome entra como texto, nunca como html: ele vem de quem escreveu a avaliação */
      contaRev.textContent = anuncio;
    }
    btPrev.addEventListener('click', function () { andar(-1); });
    btNext.addEventListener('click', function () { andar(1); });

    folha.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      /* no vídeo as setas são do vídeo (avançar e voltar), e trocar de avaliação apagaria o vídeo */
      if (e.target.closest && e.target.closest('video, audio, iframe')) return;
      if (e.key === 'ArrowLeft' && !btPrev.disabled) { e.preventDefault(); andar(-1); }
      else if (e.key === 'ArrowRight' && !btNext.disabled) { e.preventDefault(); andar(1); }
    });

    q('[data-nt-leitor-fechar]').addEventListener('click', function () {
      voltarPara = null;
      folha.close();
    });
    /* clique fora da caixa fecha */
    folha.addEventListener('click', function (e) {
      if (e.target === folha) folha.close();
    });

    /* o foco volta para o cartão da avaliação que estava aberta. a largura pode ter mudado com o leitor
       aberto (o tablet girou), e a fileira repaginou pelo começo da página: ela volta para essa avaliação */
    folha.addEventListener('close', function () {
      quadro.querySelectorAll('video, iframe').forEach(function (m) { m.remove(); });
      if (voltarPara || !atual) return;
      sincronizarPagina(atual);
      if (atual.hidden) return;
      /* com a página remontada na nova largura, o cartão pode ter saído da tela na vertical */
      var naTela = atual.getBoundingClientRect();
      if (naTela.bottom <= 0 || naTela.top >= window.innerHeight) atual.scrollIntoView({ block: 'center', inline: 'nearest' });
      var botao = atual.querySelector('[data-nt-ler]');
      if (botao) botao.focus({ preventScroll: true });
    });
  }

  /* abas: escondem os cartões da outra origem e mandam a paginação recontar a partir da primeira página */
  function ligarAbas(raiz) {
    var barra = raiz.querySelector('[data-nt-aba]');
    if (!barra) return;
    var grade = raiz.querySelector('nt-reviews');
    raiz.querySelectorAll('[data-nt-aba]').forEach(function (aba) {
      aba.addEventListener('click', function () {
        var alvo = aba.dataset.ntAba;
        raiz.querySelectorAll('[data-nt-aba]').forEach(function (outra) {
          var on = outra === aba;
          outra.classList.toggle('is-active', on);
          outra.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        raiz.querySelectorAll('[data-nt-review]').forEach(function (card) {
          card.dataset.ntFora = card.dataset.ntOrigem === alvo ? '' : '1';
        });
        if (grade && grade.reset) grade.reset();
        /* no celular a fileira da outra aba começa do primeiro cartão */
        if (grade) grade.scrollLeft = 0;
      });
    });
    /* estado inicial: a aba de produto já nasce ativa no markup */
    raiz.querySelectorAll('[data-nt-review]').forEach(function (card) {
      card.dataset.ntFora = card.dataset.ntOrigem === 'produto' ? '' : '1';
    });
    if (grade && grade.reset) grade.reset();
  }

  /* a fileira de arrastar do celular e as páginas do desktop mostram a mesma avaliação quando a largura
     cruza o limite: a primeira à vista na fileira vira o começo da página, e o começo da página vai para o
     começo da fileira */
  function ligarFileira(raiz) {
    var grade = raiz.querySelector('nt-reviews');
    if (!grade || grade.dataset.ntFileira) return;
    grade.dataset.ntFileira = '1';
    var espera = 0;
    function rola() { return grade.scrollWidth > grade.clientWidth + 1; }
    function passo() {
      var c = grade.cards || [];
      if (c.length < 2) return 0;
      return c[1].getBoundingClientRect().left - c[0].getBoundingClientRect().left;
    }
    grade.addEventListener('scroll', function () {
      window.clearTimeout(espera);
      espera = window.setTimeout(function () {
        var p = passo();
        if (!rola() || p <= 0) return;
        grade.ancora = Math.min(grade.cards.length - 1, Math.round(grade.scrollLeft / p));
      }, 120);
    }, { passive: true });
    grade.addEventListener('nt-rev-render', function () {
      if (!rola()) return;
      var p = passo();
      var i = grade.ancora != null ? Math.min(grade.ancora, grade.cards.length - 1) : 0;
      if (p > 0) grade.scrollLeft = i * p;
    });
  }

  /* as fotos dos cartões chegam antes de aparecer. o lazy do navegador só pede a foto quando ela já está
     entrando na tela: na fileira de arrastar a seguinte fica fora da caixa que rola, e no desktop as páginas
     seguintes estão escondidas e nunca são pedidas antes do clique. aqui o loading do próprio cartão vira
     eager um pouco antes, e o navegador escolhe o arquivo pelo srcset e sizes do cartão, como faria */
  function ligarAquecimento(raiz) {
    var grade = raiz.querySelector('nt-reviews');
    if (!grade || grade.dataset.ntAquece) return;
    grade.dataset.ntAquece = '1';
    var perto = false;
    var quadro = 0;

    function rola() { return grade.scrollWidth > grade.clientWidth + 1; }
    function cartoes() { return grade.cards || []; }
    function fotoDe(card) { return card && card.querySelector('.nt-rev__foto img'); }
    function passo() {
      var c = cartoes();
      if (c.length < 2) return 0;
      return c[1].getBoundingClientRect().left - c[0].getBoundingClientRect().left;
    }
    function economia() { return !!(navigator.connection && navigator.connection.saveData); }
    /* conexão fraca ou economia de dados: só o que a pessoa já está para ver, nada em segundo plano */
    function fraca() {
      var c = navigator.connection;
      return !!c && (c.saveData || /2g|3g/.test(c.effectiveType || ''));
    }

    function pedir(card, devagar) {
      var img = fotoDe(card);
      if (!img || img.loading !== 'lazy') return img;
      if (devagar) img.fetchPriority = 'low';
      img.loading = 'eager';
      return img;
    }
    function pedirFaixa(de, ate) {
      var c = cartoes();
      for (var i = Math.max(0, de); i < Math.min(c.length, ate); i++) pedir(c[i]);
    }

    /* no celular, os três cartões à frente do que está na tela; no desktop, a página de antes e a de depois */
    function aquecerPerto() {
      quadro = 0;
      if (!perto || !cartoes().length) return;
      if (rola()) {
        var p = passo();
        var i = p > 0 ? Math.floor(grade.scrollLeft / p) : 0;
        var naTela = p > 0 ? Math.ceil(grade.clientWidth / p) : 1;
        pedirFaixa(i, i + naTela + 3);
      } else {
        var s = grade.size || 1;
        var pg = grade.page || 0;
        pedirFaixa((pg - 1) * s, (pg + 2) * s);
      }
    }
    function agendar() {
      if (!quadro) quadro = window.requestAnimationFrame(aquecerPerto);
    }
    grade.addEventListener('scroll', agendar, { passive: true });
    grade.addEventListener('nt-rev-render', agendar);

    if ('IntersectionObserver' in window) {
      /* a seção chegando perto da tela: os primeiros cartões (no desktop, a página 1 e a 2) */
      var chegada = new IntersectionObserver(function (entradas) {
        if (!entradas.some(function (e) { return e.isIntersecting; })) return;
        chegada.disconnect();
        perto = true;
        agendar();
        talvezFila();
      }, { rootMargin: '1250px 0px' });
      chegada.observe(raiz);

      /* no celular, o cartão parado inteiro na tela por um segundo é o que a pessoa está lendo: a foto do
         leitor dele vem antes do toque, que sozinho chega tarde demais para ela */
      var olhando = new Map();
      var olho = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var card = e.target;
          if (e.intersectionRatio >= 0.9) {
            if (olhando.has(card)) return;
            olhando.set(card, window.setTimeout(function () {
              olhando.delete(card);
              if (rola() && !economia()) aquecerLeitor(card);
            }, 1000));
          } else if (olhando.has(card)) {
            window.clearTimeout(olhando.get(card));
            olhando.delete(card);
          }
        });
      }, { threshold: [0, 0.9] });
      grade.querySelectorAll('[data-nt-midia="1"]').forEach(function (card) { olho.observe(card); });
    } else {
      perto = true;
    }

    /* fila de fundo: com a página carregada e o navegador ocioso, as fotos dos cartões na ordem em que a pessoa
       vai vê-las (a da fileira, aba aberta), duas por vez e com prioridade baixa, até um teto: uns 10 cartões
       no celular, três páginas no desktop. as fotos grandes do leitor não entram */
    function fila() {
      if (fraca()) return;
      var celular = rola();
      var tetoFotos = celular ? 10 : (grade.size || 4) * 3;
      var tetoBytes = celular ? 1500000 : 3000000;
      var feitas = 0;
      var bytes = 0;
      var i = 0;
      var rodando = 0;
      function peso(img) {
        var lista = window.performance && performance.getEntriesByName ? performance.getEntriesByName(img.currentSrc || img.src) : [];
        var r = lista[lista.length - 1];
        /* foto de outro domínio sem o tamanho exposto conta como uma média */
        return r && r.encodedBodySize ? r.encodedBodySize : 80000;
      }
      function esperar(img) {
        var fim = false;
        function pronto() {
          if (fim) return;
          fim = true;
          rodando--;
          bytes += peso(img);
          proxima();
        }
        img.addEventListener('load', pronto, { once: true });
        img.addEventListener('error', pronto, { once: true });
        window.setTimeout(pronto, 15000);
      }
      function proxima() {
        var c = cartoes();
        while (rodando < 2 && i < c.length && feitas < tetoFotos && bytes < tetoBytes) {
          var card = c[i++];
          var img = fotoDe(card);
          if (!img) continue;
          feitas++;
          if (img.complete && img.naturalWidth) { bytes += peso(img); continue; }
          rodando++;
          esperar(pedir(card, true));
        }
      }
      proxima();
    }
    function ocioso() {
      if (window.requestIdleCallback) window.requestIdleCallback(fila, { timeout: 4000 });
      else window.setTimeout(fila, 300);
    }
    /* nada começa antes do load (o segundo de folga deixa passar o que os apps da loja carregam logo depois) nem
       antes de a seção chegar perto da tela: quem não rola até as avaliações não baixa as fotos delas */
    var carregou = false;
    var filaPedida = false;
    function talvezFila() {
      if (!carregou || !perto || filaPedida) return;
      filaPedida = true;
      ocioso();
    }
    function depoisDoLoad() { window.setTimeout(function () { carregou = true; talvezFila(); }, 1000); }
    if (document.readyState === 'complete') depoisDoLoad();
    else window.addEventListener('load', depoisDoLoad, { once: true });
  }

  document.querySelectorAll('.nt-rev').forEach(function (raiz) {
    ligar(raiz);
    ligarAbas(raiz);
    ligarFileira(raiz);
    ligarAquecimento(raiz);
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.nt-rev').forEach(function (raiz) {
      ligar(raiz);
      ligarAbas(raiz);
      ligarFileira(raiz);
      ligarAquecimento(raiz);
    });
  });
})();
